import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState("login");
  const [regForm, setRegForm] = useState({ name: "", email: "", password: "" });
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(
        "https://vape-backend-1.onrender.com/api/auth/login",
        form,
      );
      login(data);
      navigate("/");
      toast.success(`Welcome back, ${data.name}!`);
    } catch (err) {
      toast.error(err.response?.data?.message || "Login failed");
    }
    setLoading(false);
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(
        "https://vape-backend-1.onrender.com/api/auth/register",
        regForm,
      );
      login(data);
      navigate("/");
      toast.success("Account created!");
    } catch (err) {
      toast.error(err.response?.data?.message || "Register failed");
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <h1>💨 VapeTrack</h1>
        <p>Vape Business Inventory System</p>

        {mode === "login" ? (
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                required
                placeholder="admin@vape.com"
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                required
                placeholder="••••••••"
              />
            </div>
            <button
              className="btn btn-primary"
              style={{ width: "100%", justifyContent: "center" }}
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
            <p
              style={{
                textAlign: "center",
                marginTop: 16,
                fontSize: "0.85rem",
                color: "var(--text-secondary)",
              }}
            >
              Don't have an account?{" "}
              <span
                style={{ color: "var(--accent)", cursor: "pointer" }}
                onClick={() => setMode("register")}
              >
                Register
              </span>
            </p>
          </form>
        ) : (
          <form onSubmit={handleRegister}>
            <div className="form-group">
              <label>Full Name</label>
              <input
                value={regForm.name}
                onChange={(e) =>
                  setRegForm({ ...regForm, name: e.target.value })
                }
                required
                placeholder="Your Name"
              />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={regForm.email}
                onChange={(e) =>
                  setRegForm({ ...regForm, email: e.target.value })
                }
                required
                placeholder="email@example.com"
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={regForm.password}
                onChange={(e) =>
                  setRegForm({ ...regForm, password: e.target.value })
                }
                required
                placeholder="••••••••"
              />
            </div>
            <button
              className="btn btn-primary"
              style={{ width: "100%", justifyContent: "center" }}
              disabled={loading}
            >
              {loading ? "Creating..." : "Create Account"}
            </button>
            <p
              style={{
                textAlign: "center",
                marginTop: 16,
                fontSize: "0.85rem",
                color: "var(--text-secondary)",
              }}
            >
              Already have account?{" "}
              <span
                style={{ color: "var(--accent)", cursor: "pointer" }}
                onClick={() => setMode("login")}
              >
                Login
              </span>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
